import { render } from "./ActiveComponent.vue?vue&type=template&id=d518bd0c&scoped=true"
import script from "./ActiveComponent.vue?vue&type=script&lang=js"
export * from "./ActiveComponent.vue?vue&type=script&lang=js"

import "./ActiveComponent.vue?vue&type=style&index=0&id=d518bd0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d518bd0c"]])

export default __exports__